// Época de festas (Natal e Réveillon) no R2 Disponibilidade: calendário, saudações, contagem regressiva e preferências.
//
// Calendário (mesmo do R2 Security, para os sistemas da R2 virarem juntos):
//   november         1 a 30/11   pré-temporada: contagem e neve bem leve
//   advent           1 a 23/12   calendário do Advento na home, a neve aumenta dia a dia
//   christmasEve     24/12       véspera
//   christmas        25/12       Natal
//   betweenHolidays  26 a 30/12  entre as festas: contagem para o Ano-Novo
//   newYearEve       31/12       Réveillon: confete, taças e fogos
//   newYearDay       1/1         Ano-Novo
//   january          2 a 11/1    bom retorno
//   null             fora da época (12/1 a 31/10): nada aparece
//
// Data de teste, só em desenvolvimento (npm run dev): abrir com ?festas=2026-12-24 (ou 2026-12-31T23:58) faz toda a
// decoração usar essa data, com o relógio andando a partir dela; ?festas=off volta ao relógio real. Fica guardada no
// navegador entre recargas. Só a decoração usa essa data: sessão, token e o resto do sistema seguem o relógio real.

const TEST_DATE_KEY = 'seasonTestDate';
let testOffset = 0;

export function readTestDate(search, storage) {
    const value = new URLSearchParams(search).get('festas');
    if (value === 'off') {
        storage.removeItem(TEST_DATE_KEY);
        return null;
    }
    if (value) storage.setItem(TEST_DATE_KEY, value);
    const saved = value || storage.getItem(TEST_DATE_KEY);
    if (!saved) return null;
    // Só a data ("2026-12-31") vale ao meio-dia, para o fuso não jogar para o dia anterior
    const date = new Date(/T/.test(saved) ? saved : `${saved}T12:00`);
    return Number.isNaN(date.getTime()) ? null : date;
}

if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    try {
        const date = readTestDate(window.location.search, window.localStorage);
        if (date) {
            testOffset = date.getTime() - Date.now();
            // eslint-disable-next-line no-console
            console.info(`[festas] data de teste: ${date.toLocaleString('pt-BR')} (?festas=off para voltar)`);
        }
    } catch (e) {
        // Armazenamento bloqueado: segue no relógio real
    }
}

// "Agora" da decoração: o relógio real ou, em desenvolvimento, a data de teste
export function seasonNow() {
    return new Date(Date.now() + testOffset);
}

// Último dia de janeiro com decoração: tudo some a partir do dia 12
export const SEASON_LAST_DAY = 11;

export function isSeason(date = seasonNow()) {
    const month = date.getMonth();
    return month === 10 || month === 11 || (month === 0 && date.getDate() <= SEASON_LAST_DAY);
}

// Réveillon: de 31/12 a 11/1 a decoração troca o Natal pelo Ano-Novo (sem gorro, confete no lugar da neve, dourado)
export function isNewYear(date = seasonNow()) {
    const month = date.getMonth();
    const day = date.getDate();
    return (month === 11 && day === 31) || (month === 0 && day <= SEASON_LAST_DAY);
}

// Gorro (logo, favicon, avatar) só no Natal
export function isHatSeason(date = seasonNow()) {
    return isSeason(date) && !isNewYear(date);
}

export function seasonPhase(date = seasonNow()) {
    if (!isSeason(date)) return null;
    const month = date.getMonth();
    const day = date.getDate();
    if (month === 10) return 'november';
    if (month === 0) return day === 1 ? 'newYearDay' : 'january';
    if (day <= 23) return 'advent';
    if (day === 24) return 'christmasEve';
    if (day === 25) return 'christmas';
    if (day <= 30) return 'betweenHolidays';
    return 'newYearEve';
}

// Datas fortes: um pouco mais de neve ou confete
export const STRONG_PHASES = ['christmasEve', 'christmas', 'newYearEve', 'newYearDay'];

// Intensidade da neve: cresce de novembro até o Natal (0.45 -> 1), fica cheia nas festas e no Réveillon e
// diminui em janeiro. Multiplica a densidade de cada céu de neve ou confete
export function seasonIntensity(date = seasonNow()) {
    const phase = seasonPhase(date);
    if (!phase) return 0;
    if (STRONG_PHASES.includes(phase)) return 1.3;
    if (phase === 'november') return 0.45 + (date.getDate() / 30) * 0.2;
    if (phase === 'advent') return 0.65 + (date.getDate() / 23) * 0.35;
    if (phase === 'january') return 0.9 - ((date.getDate() - 2) / 9) * 0.35;
    return 1;
}

// O ano que chega (ou que acabou de chegar): em dezembro, já o seguinte
export function festiveYear(date = seasonNow()) {
    return date.getMonth() === 11 ? date.getFullYear() + 1 : date.getFullYear();
}

// Saudação curta: "Boas festas", "Feliz Natal" (24 e 25/12) ou "Feliz 2027" (Réveillon)
export function seasonGreeting(date = seasonNow()) {
    const month = date.getMonth();
    const day = date.getDate();
    if (month === 11 && (day === 24 || day === 25)) return 'Feliz Natal';
    if (isNewYear(date)) return `Feliz ${festiveYear(date)}`;
    return 'Boas festas';
}

// Cumprimento pelo horário, antes da saudação da época ("Boa tarde, Ana")
export function dayPeriodGreeting(date = seasonNow()) {
    const hour = date.getHours();
    if (hour >= 5 && hour < 12) return 'Bom dia';
    if (hour >= 12 && hour < 18) return 'Boa tarde';
    return 'Boa noite';
}

// Mensagem do cartão da home e do selo do cabeçalho: uma por fase
export function seasonMessage(date = seasonNow()) {
    const year = festiveYear(date);
    switch (seasonPhase(date)) {
    case 'advent':
        return 'Dezembro chegou. Que cada reserva fechada neste mês tenha gosto de presente.';
    case 'christmasEve':
        return 'Hoje é noite de Natal. Que a sua ceia tenha paz, afeto e boas conversas.';
    case 'christmas':
        return 'Que o seu Natal seja de paz, saúde e bons momentos com quem você ama.';
    case 'betweenHolidays':
        return `Obrigado por construir mais um ano com a gente. Que venha ${year}!`;
    case 'newYearEve':
        return 'Último dia do ano: hora de agradecer cada conquista e brindar o que vem.';
    case 'newYearDay':
        return `${year} chegou! Que o novo ano traga saúde, energia e muitos lotes vendidos.`;
    case 'january':
        return `Bom retorno! Que ${year} tenha metas claras, boas vendas e dias leves.`;
    case 'november':
        return 'O fim de ano já está no horizonte. Que estas semanas rendam ótimas vendas.';
    default:
        return '';
    }
}

// Contagem regressiva: dias até o Natal e o Ano-Novo; na véspera de cada um, horas e, na última hora, minutos.
// count e unit vêm separados para o número ganhar destaque; text é a frase inteira (leitor de tela)
const DAY = 24 * 60 * 60 * 1000;

function daysBetween(from, to) {
    return Math.round((Date.UTC(to.getFullYear(), to.getMonth(), to.getDate())
        - Date.UTC(from.getFullYear(), from.getMonth(), from.getDate())) / DAY);
}

function countdown(count, one, many, label) {
    const unit = count === 1 ? one : many;
    return {count, unit, label, text: `${count === 1 ? 'Falta' : 'Faltam'} ${count} ${unit} ${label}`};
}

function countdownToMidnight(date, target, label) {
    const left = target - date;
    const hours = Math.floor(left / 3600000);
    if (hours >= 1) return countdown(hours, 'hora', 'horas', label);
    return countdown(Math.max(1, Math.ceil(left / 60000)), 'minuto', 'minutos', label);
}

function plainMessage(label) {
    return {count: null, unit: '', label, text: label};
}

export function seasonCountdown(date = seasonNow()) {
    const year = date.getFullYear();
    const nextYear = festiveYear(date);
    switch (seasonPhase(date)) {
    case 'november':
    case 'advent':
        return countdown(daysBetween(date, new Date(year, 11, 25)), 'dia', 'dias', 'para o Natal');
    case 'christmasEve':
        return countdownToMidnight(date, new Date(year, 11, 25), 'para o Natal');
    case 'christmas':
        return plainMessage('Hoje é Natal');
    case 'betweenHolidays':
        return countdown(daysBetween(date, new Date(nextYear, 0, 1)), 'dia', 'dias', `para ${nextYear}`);
    case 'newYearEve':
        return countdownToMidnight(date, new Date(nextYear, 0, 1), `para ${nextYear}`);
    case 'newYearDay':
        return plainMessage(`${year} chegou`);
    case 'january':
        return plainMessage(`Que ${year} seja incrível`);
    default:
        return null;
    }
}

// Título da aba na época: "Reservas · Boas festas" (e "Feliz Natal" / "Feliz 2027" nas datas). As telas trocam o
// document.title por conta própria; um observador acrescenta a saudação sem precisar mexer em cada tela
const TITLE_SEPARATOR = ' · ';
const TITLE_SUFFIXES = /( · (Boas festas|Feliz Natal|Feliz \d{4}))+$/;
let titleObserver = null;
let titleDate = null;

export function seasonTitle(title, date = seasonNow()) {
    const base = (title || '').replace(TITLE_SUFFIXES, '');
    return isSeason(date) ? `${base}${TITLE_SEPARATOR}${seasonGreeting(date)}` : base;
}

function refreshTitle() {
    const next = seasonTitle(document.title, titleDate || seasonNow());
    if (next !== document.title) document.title = next;
}

export function applySeasonTitle(date = seasonNow()) {
    if (typeof document === 'undefined') return;
    titleDate = date;
    refreshTitle();
    // Fora da época basta tirar a saudação (feito acima); o observador só liga quando a época começa
    if (titleObserver || !isSeason(date) || typeof MutationObserver === 'undefined') return;
    const head = document.querySelector('head');
    if (!head) return;
    titleObserver = new MutationObserver(refreshTitle);
    titleObserver.observe(head, {subtree: true, childList: true, characterData: true});
}

// Favicon com gorro só no Natal; no Réveillon e fora da época, o de sempre. Guarda o endereço original em cada
// link para poder voltar quando a data muda com a aba aberta
export const SEASON_FAVICON = '/favicon-natal.ico';

export function applySeasonFavicon(date = seasonNow()) {
    if (typeof document === 'undefined') return;
    const hat = isHatSeason(date);
    document.querySelectorAll('link[rel~="icon"]').forEach(link => {
        if (!link.dataset.defaultHref) link.dataset.defaultHref = link.getAttribute('href');
        const href = hat ? SEASON_FAVICON : link.dataset.defaultHref;
        if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    });
}

// Preferências guardadas no navegador. O logout do sistema não limpa o localStorage inteiro, então elas ficam
function readStorage(key) {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        return null;
    }
}

function writeStorage(key, value) {
    try {
        if (value === null) window.localStorage.removeItem(key);
        else window.localStorage.setItem(key, value);
    } catch (e) {
        // Armazenamento bloqueado: vale só nesta sessão
    }
}

// Animação (neve e confete): cada pessoa pode desligar; a decoração parada continua
const EFFECTS_KEY = 'seasonEffects';

export function seasonEffectsEnabled() {
    return readStorage(EFFECTS_KEY) !== 'off';
}

export function saveSeasonEffects(enabled) {
    writeStorage(EFFECTS_KEY, enabled ? null : 'off');
}

// Calendário do Advento: portas já abertas, por ano ("2026": [1, 2, 5])
const ADVENT_KEY = 'seasonAdvent';

export function openedAdventDoors(year) {
    try {
        const saved = JSON.parse(readStorage(ADVENT_KEY) || '{}');
        return Array.isArray(saved[year]) ? saved[year].filter(Number.isInteger) : [];
    } catch (e) {
        return [];
    }
}

export function saveAdventDoor(year, day) {
    const doors = openedAdventDoors(year);
    if (doors.includes(day)) return doors;
    const next = [...doors, day].sort((a, b) => a - b);
    // Só o ano corrente fica guardado
    writeStorage(ADVENT_KEY, JSON.stringify({[year]: next}));
    return next;
}

// Porta do Advento disponível: de 1 até o dia de hoje, só em dezembro (do dia 1 ao 25)
export function adventToday(date = seasonNow()) {
    if (date.getMonth() !== 11 || date.getDate() > 25) return 0;
    return Math.min(24, date.getDate());
}

export function prefersReducedMotion() {
    return typeof window !== 'undefined' && !!window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
